import type { FC } from 'react'

import { useNoFundsTimer } from '@web-solutions/core/summary/special-offer/hooks'

import classes from './style.module.scss'

export const Timer: FC = () => {
  const { shown, time } = useNoFundsTimer()

  return (
    shown && <p className={classes.timer}>{time}</p>
  )
}

